import * as React from 'react';
import { connect } from 'react-redux';

import ActionButton from 'components/buttons/action-button/ActionButton';
import InfluencerDeleteButton from 'components/influencer-tile/influencer-delete-button/InfluencerDeleteButton';

import * as AdminPanel from '../admin-panel';
import CollabarySupport from '../admin-panel/collabary-support/CollabarySupport';
import ProfileApprovalPanel from './profile-approval-panel/ProfileApprovalPanel';
import ProfileOutfitPanel from './profile-outfit-panel/ProfileOutfitPanel';
import ProfileDuplicatedProfiles from './profile-duplicated-profiles/ProfileDuplicatedProfiles';
import ProfileHideFromSearch from './profile-hide-from-search/ProfileHideFromSearch';

import { forceProfileUpdate } from 'modules/admin/reducers/admin-profiles';

import { __t, applyTranslations } from 'utils/language';
import { redirectToCreatorsSearch } from 'utils/routes';

import type { InfluencerProfile } from 'types';

applyTranslations(require('./profile-admin-panel.i18n.json'));

type OwnProps = {
  isAdmin: boolean,
  hasRealmRole: boolean,
  profile: InfluencerProfile,
  isLightweightProfileMaintainer: boolean,
  onChange: () => void
};

type DispatchProps = {
  dispatchForceProfileUpdate: () => void
};

type Props = OwnProps & DispatchProps;

const ProfileAdminPanel = (props: Props): JSX.Element => {
  const {
    isAdmin,
    hasRealmRole,
    profile,
    isLightweightProfileMaintainer,
    onChange,
    dispatchForceProfileUpdate
  } = props;
  const { isLightweight } = profile;

  return (
    <AdminPanel.Panel>
      {isAdmin && !isLightweight && (
        <AdminPanel.Block>
          <ProfileApprovalPanel
            profile={profile}
            onChange={onChange}
          />
        </AdminPanel.Block>
      )}
      {isAdmin && (
        <AdminPanel.Block>
          <AdminPanel.BlockTitle
            title={__t('profile_admin_panel.update_profile_title')}
            tooltip={__t('profile_admin_panel.update_profile_tooltip')}
          />
          <ActionButton onClick={dispatchForceProfileUpdate}>
            {__t('profile_admin_panel.update_profile_button')}
          </ActionButton>
        </AdminPanel.Block>
      )}
      {isAdmin && !isLightweight && (
        <AdminPanel.Block>
          <AdminPanel.BlockTitle
            title={__t('profile_admin_panel.toggle_support_title')}
            tooltip={__t('profile_admin_panel.toggle_support_tooltip')}
          />
          <CollabarySupport
            profile={profile}
            profileType="influencer"
          />
        </AdminPanel.Block>
      )}
      {(isAdmin || hasRealmRole) && !isLightweight && (
        <AdminPanel.Block>
          <ProfileOutfitPanel
            profile={profile}
            onChange={onChange}
          />
        </AdminPanel.Block>
      )}
      {isAdmin && (
        <AdminPanel.Block>
          <ProfileHideFromSearch
            profile={profile}
            onChange={onChange}
          />
        </AdminPanel.Block>
      )}
      {isAdmin && !isLightweight && (
        <AdminPanel.Block>
          <ProfileDuplicatedProfiles
            profile={profile}
          />
        </AdminPanel.Block>
      )}
      {isAdmin && isLightweight && isLightweightProfileMaintainer && (
        <AdminPanel.Block>
          <AdminPanel.BlockTitle title={__t('profile_admin_panel.delete_lightweight')} />
          <InfluencerDeleteButton
            influencer={profile}
            onDeleteProfile={redirectToCreatorsSearch}
          />
        </AdminPanel.Block>
      )}
    </AdminPanel.Panel>
  );
};

function mapDispatchToProps(dispatch, ownProps: OwnProps): DispatchProps {
  return {
    dispatchForceProfileUpdate: () => dispatch(forceProfileUpdate(ownProps.profile.id))
  };
}

export default connect(undefined, mapDispatchToProps)(ProfileAdminPanel);
